import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import './UserList.css'; // Импорт CSS файла

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/users');
      if (response) {
        setUsers(response);
      } else {
        setError('Неправильный формат данных с сервера');
      }
    } catch (error) {
      console.error('Ошибка при загрузке пользователей:', error);
      setError('Ошибка при загрузке пользователей');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Функция удаления роли: roleId передаётся через тело запроса
  const handleRemoveRole = async (userId, roleName) => {
    const confirmed = window.confirm('Вы уверены, что хотите удалить роль у пользователя?');
    if (!confirmed) return;
    try {
      // Передаём roleName в URL
      await api.delete(`/roles/users/${userId}/roles/${roleName}`);
      alert('Роль успешно удалена');
      fetchUsers(); // Обновляем список пользователей после удаления
    } catch (error) {
      console.error('Ошибка при удалении роли:', error);
      setError('Ошибка при удалении роли');
    }
  };
  
  
  

  if (loading) {
    return <div className="userlist-loading">Загрузка пользователей...</div>;
  }

  if (error) {
    return <div className="userlist-error">Ошибка: {error}</div>;
  }

  if (!users || users.length === 0) {
    return <div className="userlist-empty">Пользователи не найдены.</div>;
  }

  return (
    <div className="userlist-container">
      <h2 className="userlist-title">Список пользователей</h2>
      {users.map(user => (
            <div key={user.id} className="userlist-row">
                <div className="userlist-info">
                <div className="userlist-field">
                    <span className="userlist-label">ID:</span> {user.id}
                </div>
                <div className="userlist-field">
                    <span className="userlist-label">Имя:</span> {user.username}
                </div>
                <div className="userlist-field">
                    <span className="userlist-label">Email:</span> {user.email || 'нет'}
                </div>
                <div className="userlist-field">
                    <span className="userlist-label">Роль:</span> {user.role ? user.role.name : 'нет'}
                </div>
                </div>
                {user.role && (
                <button 
                    className="userlist-remove-button" 
                    onClick={() => handleRemoveRole(user.id, user.role.name)}
                >
                    Удалить роль
                </button>
                )}
            </div>
            ))}

    </div>
  );
};

export default UserList;
